import { render } from "./InteractiveVotingPublicModal.vue?vue&type=template&id=4f5c884e&scoped=true"
import script from "./InteractiveVotingPublicModal.vue?vue&type=script&lang=js"
export * from "./InteractiveVotingPublicModal.vue?vue&type=script&lang=js"

import "./InteractiveVotingPublicModal.vue?vue&type=style&index=0&id=4f5c884e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5c884e"]])

export default __exports__